export default "__VITE_ASSET__1e346060__"